<template>
  <div>
    <v-card max-width="100%">
      <v-card-title>
        <h4>SIAPA - Solicitudes Usuarios WEB</h4>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="solicitudes"
          :items-per-page="10"
          :items-per-page-options="[5, 10, 25, 50, -1]"
          :search="search"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-text-field
              v-model="search"
              label="Buscar"
              class="mx-4"
              prepend-inner-icon="mdi-magnify"
              single-line
              hide-details
            ></v-text-field>
          </template>
          <template v-slot:item.fechaNacimiento="{ item }">
            {{ item.fechaNacimiento | formatDate }}
          </template>
          <template v-slot:item.fechaAlta="{ item }">
            {{ item.fechaAlta | formatDate }}
          </template>
          <template v-slot:item.autor="{ item }">
            {{ item.autor ? item.autor.nombres + " " + item.autor.apellidos : "" }}
          </template>
          <template v-slot:item.idSocio="{ item }">
            {{ item.autor ? +item.autor.gestionIdSocio : "" }}
          </template>
          <template v-slot:item.estado="{ item }">
            <v-chip :class="`${item.estado} my-2 caption`">{{ item.estado }}</v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <AsignarAutorUsuarioWeb
              :solicitud_id="item.id"
              @asignado="asignado"
              v-if="!item.autor"
            />
            <Confirmar
              v-if="item.estado == 'Habilitado'"
              boton="Reset"
              titulo="¿Enviar email para restabler la contraseña?"
              @si="resetPassword(item)"
            />
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="$router.push('/')">Volver</v-btn>
        <v-spacer></v-spacer>

        <v-spacer></v-spacer>

        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar" :timeout="3000">
      Correo enviado!
      <v-btn color="blue" text @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import axios2 from "@/axios-auth";
import moment from "moment";
import Confirmar from "@/components/Confirmar.vue";
import AsignarAutorUsuarioWeb from "@/components/usuarioWeb/AsignarAutorUsuarioWeb";

export default {
  data() {
    return {
      solicitudes: [],
      snackbar: false,
      search: "",
      headers: [
        { text: "ID", value: "id" },
        { text: "Cédula", value: "cedula" },
        { text: "Nombres", value: "nombres" },
        { text: "Apellidos", value: "apellidos" },
        { text: "Celular", value: "celular" },
        { text: "Email", value: "email" },
        { text: "Fecha Nacimiento", value: "fechaNacimiento" },
        { text: "Fecha Alta", value: "fechaAlta" },
        { text: "Socio", value: "idSocio" },
        { text: "Autor", value: "autor" },
        { text: "Estado", value: "estado" },
        { text: "Acciones", value: "actions", sortable: false }
      ]
    };
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY hh:mm");
      }
    }
  },
  components: {
    AsignarAutorUsuarioWeb,
    Confirmar
  },
  mounted() {
    axios
      .get("/solicitudUsuarioWeb")
      .then(response => {
        this.solicitudes = response.data
          .reverse()
          .filter(e => e.emailVerificado);

        this.ordenarSolicitudes();
        console.log(response);
      })
      .catch(err => {
        console.log(err);
        this.errorMessage = "Error en la consulta";
      });
  },
  methods: {
    test(a) {
      console.log(a);
    },
    detalle(id) {
      this.$router.push({ path: `/pago/${id}` });
    },
    asignado(data) {
      this.solicitudes.forEach(e => {
        if (e.id == data.solicitud_id) {
          e.autor = data.autor;
          return;
        }
      });
    },
    ordenarSolicitudes() {
      this.solicitudes = this.solicitudes.sort((a, b) => {
        //ordenamos por estado y id dec
        if (a.estado > b.estado) return -1;
        if (a.estado < b.estado) return 1;

        if (a.id > b.id) return -1;
        if (a.id < b.id) return 1;
      });

      // this.solicitudes = this.solicitudes.sort( (a, b) => {
      //   if () {
      //     return -1
      //   }
      // });

      //this.solicitudes = this.solicitudes.sort( (a, b) => a.id > b.id);
    },
    resetPassword(sol) {
      console.log(sol);
      axios2
        .post("/singup/resetPassword", {
          cedula: sol.cedula,
          correo: sol.email
        })
        .then(() => {
          this.loading = false;
          this.snackbar = true;
        })
        .catch(err => {
          this.loading = false;
          this.errorMessage = "Cédula y/o dirección de correo inválido";
          console.log(err);
        });
    }
  }
};
</script>

<style scoped>
.v-chip.Abierto {
  background: lightgreen;
}

.v-chip.Validado {
  background: lightcoral;
}

.v-chip.Cerrado {
  background: lightgray;
}
</style>
